module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "red darken-4",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), (_vm.canAdd) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.displayedUsers), function(user, index) {
    return [_c('v-list-tile', {
      key: user.id,
      class: {
        'red': user.id == _vm.selectedUserId, 'lighten-4': user.id == _vm.selectedUserId
      },
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectUser(user.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      }
    }, [(_vm.noPasswordUser(user)) ? _c('v-icon', {
      attrs: {
        "slot": "activator",
        "color": "pink"
      },
      slot: "activator"
    }, [_vm._v("error")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("L'utilisateur n'a pas encore activé son compte")])], 1), _vm._v(" "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(_vm.unreadMessageCount(user.id) > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount(user.id)))]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.displayName(user)))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(user.extra.tag))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.userToDelete = _vm.clone(user);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.users.length) ? _c('v-divider', {
      key: user.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.users.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.displayName(_vm.userToDelete)) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteUser(_vm.userToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58783348","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserList.vue
// module id = 1193
// module chunks = 1